<template>
  <div class="home">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-content">
        <h1 class="hero-description">{{ $t('home.description') }}</h1>
        <div class="button-group">
          <button class="cta-button" @click="goToApartments">
            {{ $t('home.accommodated') }}
          </button>
          <button class="cta-button" @click="goToTips">
            {{ $t('home.notAccommodated') }}
          </button>
        </div>
      </div>
      <!-- Hero background image -->
      <div class="hero-background" :style="{ backgroundImage: `url(${require('@/assets/images/hero.jpg')})` }"></div>
    </section>
  </div>
</template>

<script>
import { logMessage } from '../../utils/flaskapi';

export default {
  name: 'HomeView',
  methods: {
    scrollToContent() {
      // Smooth scroll to main content
      document.querySelector('.main-content').scrollIntoView({ 
        behavior: 'smooth' 
      });
    },
    goToApartments() {
      logMessage('info', 'Home_goToApartments');
      const routeMappings = {
        'en': '/apartments',
        'sk': '/apartmany',
        'de': '/apartments',
        'pl': '/apartamenty',
        'hu': '/apartmanok'
      };
      const path = `/${this.$i18n.locale}${routeMappings[this.$i18n.locale] || '/apartments'}`;
      this.$router.push(path);
    },
    goToTips() {
      logMessage('info', 'Home_goToTips');
      const routeMappings = {
        'en': '/tips',
        'sk': '/tipy',
        'de': '/tipps',
        'pl': '/porady',
        'hu': '/tippek'
      };
      const path = `/${this.$i18n.locale}${routeMappings[this.$i18n.locale] || '/tips'}`;
      this.$router.push(path);
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');

.home {
  font-family: 'Lato', sans-serif;
}

.hero {
  position: sticky;
  top: 0;
  height: 80vh; /* Adjust height as needed */
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
}

.hero-content {
  position: relative;
  z-index: 2;
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.hero h1 {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 3rem;
  margin-bottom: 1.5rem;
  margin-top: 1em;
  color: white; /* Make text visible on background */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* Add shadow for better readability */
}

.hero-description {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  color: white; /* Make text visible on background */
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.9); /* Add shadow for better readability */
}
.hero-background {
  transform: scaleX(-1); /* Add horizontal flip */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  opacity: 0.75;
  z-index: 1;
}
.button-group {
  padding-bottom: 5em;
}
.cta-button {
  padding: 1rem 2rem;
  margin: 1rem 1rem;
  font-size: 1.1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cta-button:hover {
  background-color: var(--primary-color-dark);
}

.main-content {
  padding: 4rem 2rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .hero {
    height: 70vh;
  }

  .hero h1 {
    font-size: 2rem;
  }

  .hero-description {
    font-size: 1.1rem;
  }
}
</style> 